import script from "./NotificationSetting.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotificationSetting.vue?vue&type=script&lang=ts&setup=true"

import "./NotificationSetting.vue?vue&type=style&index=0&id=0e87e05b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e87e05b"]])

export default __exports__